window.PlummeI18n.register('en', {
  'inv.pay.undoPayment': 'Undo payment',
  'inv.pay.undoRefund': 'Undo refund',
  'inv.pay.undoPaymentTitle': 'Undo registered payment?',
  'inv.pay.undoRefundTitle': 'Undo registered refund?',
  'inv.pay.undoPaymentBody': 'The payment will be reversed and the invoice reopened with the corresponding outstanding amount. The original entry remains in the audit trail.',
  'inv.pay.undoRefundBody': 'The refund will be reversed and the customer credit reopened. The original entry remains in the audit trail.',
  'inv.toast.paymentReversed': 'Payment reversed',
  'inv.toast.refundReversed': 'Refund reversed',
  'inv.err.paymentReverseFailed': 'Could not reverse the payment.',
  'inv.err.refundReverseFailed': 'Could not reverse the refund.',
});
